import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiGroups: ApiType = {
  get: {
    search: ({ query, vars }) =>
      api.get(stringParse('/api/groups?search={0}&isActive=true', vars), query),
    list: ({ vars }) => api.get(stringParse('/api/groups?isActive=true', vars)),
  },
  put: {},
  post: {},
  delete: {},
};
